
export const environment = {
   production: false,
   apiUrl: 'https://54-144-142-235.sslip.io/api',
   // Opt-in NGXS action logging. It MUST be emitted here even when false:
   // core/index.ts reads environment.ngxsLogger, so a generated file without
   // it fails the build — which only showed up when the frontend container
   // was recreated and this file was rewritten.
   ngxsLogger: false,
   recaptcha: {
    siteKey: 'undefined'
   },
   cognito: {
    userPoolId: 'undefined',
    userPoolWebClientId: 'undefined',
  }
};
